import { Component, EventEmitter, OnInit, Output, TemplateRef, ViewChild } from "@angular/core";
import { TranslatePipe, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { injectTranslation } from "@app/shared/i18n/translation-scope";
import { scope as assetManagementScope } from "@app/assetmanagement/i18n/scope";
import { scope } from "@app/shared/organisms/cerrix-linked-item-table/i18n/scope";
import { LinkedItemTableOverviewDirective, LinkedItemTableDetailDirective } from "@app/shared/organisms/cerrix-linked-item-table/linked-item-table-template-context.directive";
import { LinkedItemTableCellContext, LinkedItemTableDetailContext, LinkedItemTableTemplates } from "@app/shared/organisms/cerrix-linked-item-table/linked-item-table-template.models";
import { CerrixColorBoxLabelComponent } from "@app/shared/molecules/cerrix-color-box-label/cerrix-color-box-label.component";
import { CerrixAvatarComponent } from "@app/shared/atoms/cerrix-avatar/cerrix-avatar.component";
import { LinkedRiskTableItem, LinkedRiskTableDetails } from "./linked-risk-table.models";

@Component({
    selector: "app-linked-risk-row",
    imports: [LinkedItemTableOverviewDirective, LinkedItemTableDetailDirective, CerrixColorBoxLabelComponent, CerrixAvatarComponent, TranslatePipe],
    viewProviders: [provideTranslationScope(scope)],
    styleUrl: "../../../../shared/organisms/cerrix-linked-item-table/shared/linked-item-table-renderers.scss",
    templateUrl: "./linked-risk-row.component.html",
})
export class LinkedRiskRowComponent implements OnInit, LinkedItemTableTemplates<LinkedRiskTableItem, LinkedRiskTableDetails> {
    private readonly translation = injectTranslation(assetManagementScope);
    private headers = { name: "", gross: "", net: "" };
    protected confidentialLabel = "";
    /** Emits when the user clicks a confidential risk, which does not expand. */
    @Output() confidentialRowClick = new EventEmitter<LinkedRiskTableItem>();
    @ViewChild("overviewRow", { static: true }) overviewRow: TemplateRef<LinkedItemTableCellContext<LinkedRiskTableItem>>;
    @ViewChild("detailRow", { static: true }) detailRow: TemplateRef<LinkedItemTableDetailContext<LinkedRiskTableItem, LinkedRiskTableDetails>>;
    readonly itemKey = (item: LinkedRiskTableItem) => item.id;
    readonly detailContext: LinkedItemTableDetailContext<LinkedRiskTableItem, LinkedRiskTableDetails> | null = null;

    async ngOnInit(): Promise<void> {
        await this.translation.ready();
        this.headers = {
            name: this.translation.t("linkedItems.risks.nameHeader"),
            gross: this.translation.t("linkedItems.risks.grossRiskHeader"),
            net: this.translation.t("linkedItems.risks.netRiskHeader"),
        };
        this.confidentialLabel = this.translation.t("linkedItems.risks.confidential");
    }

    get columns(): LinkedItemTableTemplates<LinkedRiskTableItem, LinkedRiskTableDetails>["columns"] {
        return [
            { key: "name", header: this.headers.name },
            { key: "gross", header: this.headers.gross, width: "var(--linked-item-table-value-column-width)" },
            { key: "net", header: this.headers.net, width: "var(--linked-item-table-value-column-width)" },
        ];
    }
}
